import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90e53904"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLOrderHeader" }
const _hoisted_2 = { class: "FTLOrderHeader__container" }
const _hoisted_3 = { class: "container__general" }
const _hoisted_4 = { class: "general__title" }
const _hoisted_5 = { class: "general__cheaps" }
const _hoisted_6 = { class: "container__actions" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print mr-2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print mr-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print mr-2" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload mr-2" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print mr-2" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getTitle) + " (ID: " + _toDisplayString(_ctx.$route.params.order_id) + ")", 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_cheap, {
            class: _normalizeClass(["small font-bold", _ctx.ftlOrderStatusCheapClass])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.orderStatus), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_cheap, {
            class: _normalizeClass(["small", { green: _ctx.isBillingEnabled }])
          }, {
            default: _withCtx(() => [
              (_ctx.isBillingEnabled)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Биллинг включен ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Биллинг выключен ")
                  ], 64))
            ]),
            _: 1
          }, 8, ["class"]),
          (_ctx.alreadyHaveOneC)
            ? (_openBlock(), _createBlock(_component_cheap, {
                key: 0,
                class: "small red ml-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 1С документ проведен ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.isIntracity)
          ? (_openBlock(), _createBlock(_component_button_dropdown, {
              key: 0,
              title: "Выберите действие",
              placement: "bottom",
              "allowed-placements": ['bottom']
            }, {
              default: _withCtx(() => [
                (_ctx.isCanAssignStatusOnTheWay && (!_ctx.isNeedCar || _ctx.carrierId))
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 0,
                      class: "primary text green small",
                      disabled: _ctx.isStatusLoading,
                      loading: _ctx.isStatusLoading,
                      onClick: _ctx.assignStatusOnTheWay
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Присвоить статус \"В пути\" ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanAssignStatusDelivered)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 1,
                      class: "primary text green small",
                      disabled: _ctx.isDeliveredLoading,
                      loading: _ctx.isDeliveredLoading,
                      onClick: _ctx.emitDelivered
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Присвоить статус \"Доставлен\" ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanUpdateFtlIntracityOrder && !_ctx.isEdit)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      to: `/ftl-orders/${_ctx.$route.params.order_id}/edit`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_the_button, { class: "primary small" }, {
                          default: _withCtx(() => [
                            _hoisted_7,
                            _createTextVNode(" Редактировать ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_the_button, {
                  class: _normalizeClass(["primary small", { text: _ctx.isInvoicesPrinting }]),
                  disabled: _ctx.isInvoicesPrinting,
                  loading: _ctx.isInvoicesPrinting,
                  onClick: _ctx.onPrintInvoices
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Печать накладных ")
                  ]),
                  _: 1
                }, 8, ["class", "disabled", "loading", "onClick"]),
                (Boolean(_ctx.scan))
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 3,
                      class: "primary small",
                      onClick: _ctx.onDownloadScan
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Скачать скан ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_ctx.isCanUploadScan)
                    ? (_openBlock(), _createBlock(_component_the_button, {
                        key: 4,
                        class: "primary small",
                        onClick: _ctx.onUploadScan
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Загрузить скан ")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                (_ctx.isOrderStatusCreated && _ctx.isNeedCar && !_ctx.carrierId)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 5,
                      class: "primary small",
                      disabled: _ctx.isCarrierLoading,
                      loading: _ctx.isCarrierLoading,
                      onClick: _ctx.emitCarrier
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Внести данные о перевозчике ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanAssignStatusCompleted)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 6,
                      class: "primary small",
                      disabled: _ctx.isCompleteLoading,
                      loading: _ctx.isCompleteLoading,
                      onClick: _ctx.emitCompleteIntracity
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Завершить заказ ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_the_button, {
                  class: _normalizeClass(["primary small", { text: _ctx.isTranscriptPrinting }]),
                  loading: _ctx.isTranscriptPrinting,
                  disabled: _ctx.isTranscriptPrinting,
                  onClick: _ctx.onPrintTranscript
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createTextVNode(" Распечатать транскрипт ")
                  ]),
                  _: 1
                }, 8, ["class", "loading", "disabled", "onClick"]),
                _createVNode(_component_the_button, {
                  class: _normalizeClass(["primary small", { text: _ctx.isRoutePrinting }]),
                  loading: _ctx.isRoutePrinting,
                  disabled: _ctx.isRoutePrinting,
                  onClick: _ctx.onPrintRoute
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createTextVNode(" Распечатать рейс ")
                  ]),
                  _: 1
                }, 8, ["class", "loading", "disabled", "onClick"]),
                (!_ctx.isBillingEnabled)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 7,
                      class: _normalizeClass(["primary small", { text: _ctx.isResendingToOneC }]),
                      loading: _ctx.isResendingToOneC,
                      disabled: _ctx.isResendingToOneC,
                      onClick: _ctx.onResendToOneC
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Переотправить АВР в 1С БУХ ")
                      ]),
                      _: 1
                    }, 8, ["class", "loading", "disabled", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanCancelFtlIntracityOrder)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 8,
                      class: "primary text red small",
                      disabled: _ctx.isStatusLoading,
                      loading: _ctx.isStatusLoading,
                      onClick: _ctx.assignStatusCanceled
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Отменить заказ ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_button_dropdown, {
              key: 1,
              title: "Выберите действие",
              placement: "bottom",
              "allowed-placements": ['bottom']
            }, {
              default: _withCtx(() => [
                (_ctx.isOrderStatusCreated)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 0,
                      class: "primary small",
                      disabled: _ctx.isStatusLoading,
                      loading: _ctx.isStatusLoading,
                      onClick: _ctx.toggleBidCreate
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Создание заявки логиста ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isLogistBidSigned)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 1,
                      class: "primary text small",
                      disabled: _ctx.isStatusLoading,
                      loading: _ctx.isStatusLoading,
                      onClick: _ctx.assignStatusOnTheWay
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Присвоить статус \"В пути\" ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanAssignStatusExportDeclarationIssued)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 2,
                      class: _normalizeClass(["primary small", { text: _ctx.isStatusLoading }]),
                      disabled: _ctx.isStatusLoading,
                      loading: _ctx.isStatusLoading,
                      onClick: _ctx.assignStatusExportDeclarationIssued
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Присвоить статус \"Оформлена экспортная декларация\" (ЭК) ")
                      ]),
                      _: 1
                    }, 8, ["class", "disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanAssignStatusCrossingTheBorder)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 3,
                      class: _normalizeClass(["primary small", { text: _ctx.isStatusLoading }]),
                      disabled: _ctx.isStatusLoading,
                      loading: _ctx.isStatusLoading,
                      onClick: _ctx.assignStatusCrossingTheBorder
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Присвоить статус \"Переход границы ТС\" ")
                      ]),
                      _: 1
                    }, 8, ["class", "disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanAssignStatusInternationalDelivered)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 4,
                      class: _normalizeClass(["primary small", { text: _ctx.isStatusLoading }]),
                      disabled: _ctx.isStatusLoading,
                      loading: _ctx.isStatusLoading,
                      onClick: _ctx.assignStatusDelivered
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Присвоить статус \"Доставлен\" ")
                      ]),
                      _: 1
                    }, 8, ["class", "disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanAssignStatusDelivered)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 5,
                      class: _normalizeClass(["primary small", { text: _ctx.isStatusLoading }]),
                      disabled: _ctx.isStatusLoading,
                      loading: _ctx.isStatusLoading,
                      onClick: _ctx.assignStatusDelivered
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Присвоить статус \"Доставлен\" ")
                      ]),
                      _: 1
                    }, 8, ["class", "disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanAssignStatusCompleted)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 6,
                      class: _normalizeClass(["primary small", { text: _ctx.isStatusLoading }]),
                      disabled: _ctx.isStatusLoading,
                      loading: _ctx.isStatusLoading,
                      onClick: _ctx.assignStatusCompleted
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Завершить заказ ")
                      ]),
                      _: 1
                    }, 8, ["class", "disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_the_button, {
                  class: _normalizeClass(["primary small", { text: _ctx.isTranscriptPrinting }]),
                  loading: _ctx.isTranscriptPrinting,
                  disabled: _ctx.isTranscriptPrinting,
                  onClick: _ctx.onPrintTranscript
                }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _createTextVNode(" Распечатать транскрипт ")
                  ]),
                  _: 1
                }, 8, ["class", "loading", "disabled", "onClick"]),
                _createVNode(_component_the_button, {
                  class: _normalizeClass(["primary small", { text: _ctx.isVacationInvoiceUploading }]),
                  loading: _ctx.isVacationInvoiceUploading,
                  disabled: _ctx.isVacationInvoiceUploading,
                  onClick: _ctx.onUploadVacationInvoice
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createTextVNode(" Загрузить Накладную на отпуск ")
                  ]),
                  _: 1
                }, 8, ["class", "loading", "disabled", "onClick"]),
                (_ctx.isCanUpdateFtlOrder)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 7,
                      to: `/ftl-orders/${_ctx.$route.params.order_id}/edit`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_the_button, { class: "primary small" }, {
                          default: _withCtx(() => [
                            _hoisted_12,
                            _createTextVNode(" Редактировать ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_the_button, {
                  class: _normalizeClass(["primary small", { text: _ctx.isRoutePrinting }]),
                  loading: _ctx.isRoutePrinting,
                  disabled: _ctx.isRoutePrinting,
                  onClick: _ctx.onPrintRoute
                }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createTextVNode(" Распечатать рейс ")
                  ]),
                  _: 1
                }, 8, ["class", "loading", "disabled", "onClick"]),
                (!_ctx.isBillingEnabled)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 8,
                      class: _normalizeClass(["primary small", { text: _ctx.isResendingToOneC }]),
                      loading: _ctx.isResendingToOneC,
                      disabled: _ctx.isResendingToOneC,
                      onClick: _ctx.onResendToOneC
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Переотправить АВР в 1С БУХ ")
                      ]),
                      _: 1
                    }, 8, ["class", "loading", "disabled", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isCanCancelFtlOrder)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 9,
                      class: _normalizeClass(["primary red small", { text: _ctx.isStatusLoading }]),
                      disabled: _ctx.isStatusLoading,
                      loading: _ctx.isStatusLoading,
                      onClick: _ctx.assignStatusCanceled
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Отменить заказ ")
                      ]),
                      _: 1
                    }, 8, ["class", "disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.logistBidStatusId === 14)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 10,
                      class: "text small",
                      loading: _ctx.state.is_loading,
                      onClick: _ctx.downloadLogistBid
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Скачать заявку логиста ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_the_button, {
                  class: _normalizeClass(["primary small", { text: _ctx.isInvoicesPrinting }]),
                  disabled: _ctx.isInvoicesPrinting,
                  loading: _ctx.isInvoicesPrinting,
                  onClick: _ctx.onPrintInvoices
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Печать накладных ")
                  ]),
                  _: 1
                }, 8, ["class", "disabled", "loading", "onClick"]),
                (Boolean(_ctx.scan))
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 11,
                      class: "primary small",
                      onClick: _ctx.onDownloadScan
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Скачать скан ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_ctx.isCanUploadScan)
                    ? (_openBlock(), _createBlock(_component_the_button, {
                        key: 12,
                        class: "primary small",
                        onClick: _ctx.onUploadScan
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Загрузить скан ")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })),
        _createVNode(_component_router_link, { to: "/ftl" }, {
          default: _withCtx(() => [
            _createVNode(_component_the_button, { class: "second text small" }, {
              default: _withCtx(() => [
                _hoisted_14,
                _createTextVNode(" Назад ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}